import References from "@/singletons/references"
import SentrySingleton from "@/singletons/sentry-singleton"
import * as THREE from 'three'

export default class SceneSizeService {

    updateContainerSize(container: HTMLCanvasElement, canvas: HTMLCanvasElement): void {
        try {
            const leftPanelHeight = document.getElementById('left-panel')!.clientHeight
            const height = Math.max(container.clientWidth, leftPanelHeight) + 'px'
            container.style.height = height
            if (container.clientWidth < 500) {
                container.style.height = leftPanelHeight + 'px'
            }
            this.updateCanvasSize(container, canvas)
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }

    updateCanvasSize(container: HTMLCanvasElement, canvas: HTMLCanvasElement): void {
        try {
            canvas.width = container.clientWidth * window.devicePixelRatio
            canvas.height = container.clientHeight * window.devicePixelRatio
            canvas.style.width = container.clientWidth + 'px'
            canvas.style.height = container.clientHeight + 'px'
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }

    onWindowResize(_this: any) {
        try {
            setTimeout(() => {
                document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`)
                const container = References.instance.getSceneReferences().sceneContainer
                const canvas = References.instance.getSceneReferences().canvas
                _this.updateContainerSize(container, canvas)

                References.instance.getSceneReferences().camera.aspect = container.clientWidth / container.clientHeight
                References.instance.getSceneReferences().camera.updateProjectionMatrix()

                References.instance.getSceneReferences().renderer.setSize(container.clientWidth, container.clientHeight)
                if(References.instance.getSceneReferences().composer) {
                    References.instance.getSceneReferences().composer!.setSize(container.clientWidth, container.clientHeight)
                }

                if (References.instance.getSceneReferences().fxaaPass) {
                    const fxaaWidth = container.clientWidth * window.devicePixelRatio
                    const fxaaHeight = container.clientHeight * window.devicePixelRatio // WTF clientWidth?
                    References.instance.getSceneReferences().fxaaPass!.uniforms['resolution'].value.set(1 / fxaaWidth, 1 / fxaaHeight)
                    // References.instance.getSceneReferences().fxaaPass!.uniforms['resolution'].value.set(1 / container.clientWidth, 1 / container.clientHeight);
                }
                
            }, 300)
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }
}